import {
  Modal,
  ModalHeader,
  ModalBody,
  Table,
  Row,
  Col,
  Badge,
} from "reactstrap"
import { formatReadableDate } from "utils/formatDate"

const STATUS_BADGE = {
  pending: "warning",
  invoiced: "success",
  cancelled: "secondary",
}

const AccessoryUseRequestView = ({ isOpen, toggle, data }) => {
  if (!data) return null

  const vehicle = data.vehicle
  const status = data.status || "pending"
  const items = Array.isArray(data.items) ? data.items : []

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle} className="border-0">
        <h4 className="mb-0 fw-bold">
          Accessory Use Request{" "}
          <small className="text-muted">{data.request_no || `#${data.id}`}</small>
        </h4>
      </ModalHeader>

      <ModalBody className="px-4">
        {/* ===== Meta ===== */}
        <Row className="mb-4">
          <Col md={6}>
            <div className="mb-2">
              <strong>Vehicle:</strong>
              <div>{vehicle?.stock_id || "-"}</div>
              {vehicle?.full_chassis && (
                <div className="text-muted">{vehicle.full_chassis}</div>
              )}
            </div>
            <div className="mb-2">
              <strong>Requested By:</strong>
              <div>{data.requested_by?.name || "-"}</div>
            </div>
            {data.is_self_vehicle !== undefined &&
              data.is_self_vehicle !== null && (
                <div className="mb-2">
                  <strong>Type:</strong>{" "}
                  <Badge color={data.is_self_vehicle === false ? "secondary" : "primary"}>
                    {data.is_self_vehicle === false ? "Not self vehicle" : "Self vehicle"}
                  </Badge>
                </div>
              )}
          </Col>
          <Col md={6} className="text-md-end">
            <div className="mb-2">
              <strong>Status:</strong>{" "}
              <Badge
                color={STATUS_BADGE[status] || "secondary"}
                className="text-capitalize"
              >
                {status}
              </Badge>
            </div>
            <div className="mb-2">
              <strong>Date:</strong>
              <div>
                {data.request_date
                  ? formatReadableDate(data.request_date)
                  : "-"}
              </div>
            </div>
          </Col>
        </Row>

        {/* ===== Items ===== */}
        <Table bordered responsive className="mb-3">
          <thead className="table-light">
            <tr>
              <th style={{ width: 50 }}>#</th>
              <th>Accessory</th>
              <th>Unit</th>
              <th className="text-end">Quantity</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? (
              <tr>
                <td colSpan={5} className="text-center text-muted">
                  No accessories.
                </td>
              </tr>
            ) : (
              items.map((item, idx) => (
                <tr key={item.id ?? idx}>
                  <td>{idx + 1}</td>
                  <td>{item.accessory?.name ?? item.name ?? "-"}</td>
                  <td>{item.accessory?.unit?.name || "-"}</td>
                  <td className="text-end">{item.quantity}</td>
                  <td>{item.remarks || "-"}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>

        {data.notes && (
          <div className="mb-2">
            <strong>Notes:</strong>
            <div className="text-muted">{data.notes}</div>
          </div>
        )}
      </ModalBody>
    </Modal>
  )
}

export default AccessoryUseRequestView
